import React from "react";
import style from "./Kot.module.scss";
/**
 * @component Kot
 * @description
 * Kitchen Order Ticket (KOT) component that displays selected items
 * Along with their quantities to be printed or shown in the kitchen
 * For order preparation.
 *
 * @props
 * @param {Array} items - The full list of available items.
 * @param {Array} addedItemIds - Array of item IDs that have been selected for the order.
 * @param {Object} itemQuantities - Object mapping item IDs to their selected quantity.
 *
 * @returns {JSX.Element} - A rendered list of selected items and their quantities.
 */
function Kot({ items, addedItemIds, itemQuantities, custDetails, invoiceData }) {
  //Filtering seleced item in respective to all items
  const selectedItems = items.filter((item) => addedItemIds.includes(item._id));

  return (
    <div>
      <div className="d-flex justify-content-between">
      <div>
         <h6>
          Bill No: <span className="fw-bold">{invoiceData?.data?.invoiceNumber || ""}</span>
        </h6>
      </div>
       
        <div className="d-flex gap-2">
          <h6>Dt: {invoiceData?.data?.createdAt || ""}</h6> 
        </div>
      </div>
      <div>
        <h6>
          Table : 
          <span className="fw-bold">
            {Array.isArray(custDetails.tableNumber)
              ? custDetails.tableNumber.join(', ')
              : (custDetails.tableNumber || (Array.isArray(custDetails.tables) ? custDetails.tables.join(', ') : ''))}
          </span>
        </h6>
      </div>
      <h6>{custDetails.orderType} Customer</h6>
      {/* Main table to map item data for kot */}
      <table className={`${style.tableStyle}`}>
        <thead>
          <tr className={`${style.tableHead}`}>
            <th style={{ textAlign: "left" }}>S.NO</th>
            <th style={{textAlign: "left"}}>ITEM NAME</th>
            <th style={{ textAlign: "right" }}>Qty</th>
          </tr>
         
        </thead>
        
        <tbody style={{borderBottom: "2px solid gray"}}>
          {selectedItems.map((item, index) => (
            <tr>
              <td style={{ textAlign: "left"}}>{index+1}</td>
              <td style={{ textAlign: "left" }}>{item.name}</td>
              <td style={{ textAlign: "right" }}>{itemQuantities[item._id]}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className={`${style.thankYouText} d-flex justify-content-center`}>
        <p>!!! Thank You !!!</p>
      </div>
      <div>
        <p style={{ fontSize: "12px" }}>
          Printed on {new Date().toLocaleDateString()}{" "}
          {new Date().toLocaleTimeString("en-IN")}
        </p>
      </div>
      {/* TO-DO : made by orderly text */}
      {/* <div className="d-flex flex-column justify-content-center pt-4 thankYouCont">
        <div className="d-flex justify-content-center"><p>*****************************************************************</p></div>
      
        <div className="w-100 d-flex justify-content-center builtBy">       
          <p>Built with ❤️ by Orderly</p>
        </div>
        <div className="d-flex justify-content-center"><p>*****************************************************************</p></div> 
      </div> */}
    </div>
  );
}

export default Kot;
